import { week2UnlimitedData } from '@/data/recommend-class/unlimited.data';
import { formatKoreanCurrency } from '@/lib/utils';
import { usePricingList } from '@/services/query/pricing.query';
import {
  CategoryDto,
  PricingCategoryCode,
} from '@/services/types/pricing.type';
import { PracticeProgramCardData } from '@/types/curriculum-program.type';

const WEEK2_UNLIMITED_PRICE_LABEL = '2주 무제한';

/**
 * 2주완성 무제한 카드(week2UnlimitedData)에 요금 API 금액을 실은 사본을 돌려준다.
 * 카드 데이터의 type('2종보통 자동')과 요금 플랜의 label+subLabel('2종 보통'+'(자동)')을 맞춰 바꾸고,
 * 맞는 플랜이 없으면 데이터의 기본 금액을 그대로 둔다. 공용 데이터는 고치지 않는다.
 */
export function withWeek2UnlimitedPrices(
  pricingList: CategoryDto[] | undefined,
): PracticeProgramCardData {
  const unlimitedPricing = pricingList?.find(
    (pricing) => pricing.code === PricingCategoryCode.UNLIMITED,
  );

  return {
    ...week2UnlimitedData,
    prices: week2UnlimitedData.prices.map((price) => {
      for (const plan of unlimitedPricing?.plans ?? []) {
        const planPrice = plan.prices?.find(
          (item) => item.label === WEEK2_UNLIMITED_PRICE_LABEL,
        );
        if (!planPrice) continue;
        const planLabel = plan.label.replace(' ', '');
        const planSubLabel = plan.subLabel.replace('(', '').replace(')', '');
        if (price.type === `${planLabel} ${planSubLabel}`) {
          return { ...price, price: formatKoreanCurrency(planPrice.price) };
        }
      }
      return { ...price };
    }),
  };
}

/**
 * 2주완성 무제한 카드 데이터. 2주완성 화면과 이 카드를 함께 싣는 추천 클래스(장롱·주차·10시간·주말패스)가
 * 같은 요금 API 금액을 보이게 한다. 예전엔 2주완성 화면만 API 금액을 쓰고 나머지는 데이터의 고정 금액
 * (20만원)이라, 2주완성을 거쳐 사이트 안에서 이동했을 때만 API 금액이 보였다(2026-10-19 확인).
 * 페이지에서 prefetchPricingList 로 서버에서도 받아 HTML 에 싣는다.
 */
export function useWeek2UnlimitedCardData() {
  const { data: pricingList } = usePricingList();
  return withWeek2UnlimitedPrices(pricingList?.data);
}
